// resources/js/store/reducers/MapReducer.js

const initialeState = {
    vectoreRemoveFeature: null,
    mapRef: null,
    centerMap: null,
    currentParcelle: [],
    currentCom: null,
    currentComLabel: '',
    locationScreenCapt: null,
    moveEnd: false,
    displayMapTools: true,
}

const MapReducer = (state = initialeState, action) => {
    let refParcelles = [];

    switch (action.type) {
        case 'SET_MAP_REF':
            return {
                ...state,
                mapRef: action.data
            }
        case 'UPDATE_CENTER_MAP':
            return {
                ...state,
                centerMap: action.data.centerMap
            }
        case 'MAP_MOVE_END':
            return {
                ...state,
                moveEnd: !state.moveEnd
            }
        case 'FIND_PARCELLE_ON_LAYER':
            refParcelles = _.uniq([...state.currentParcelle, action.data.parcelleCode]);
            return {
                ...state,
                currentParcelle: refParcelles,
                currentCom: refParcelles[0] ? refParcelles[0].substring(0, 5) : null,
            }
        case 'ADD_PARCELLE_TO_LIST':
            refParcelles = _.uniq([...state.currentParcelle, action.data.parcelleCode]);
            return {
                ...state,
                currentParcelle: refParcelles,
                currentCom: refParcelles[0] ? refParcelles[0].substring(0, 5) : null,
            }
        case 'REMOVE_PARCELLE_FROM_LIST':
            refParcelles = state.currentParcelle.filter(item => item !== action.data.parcelleCode);
            return {
                ...state,
                vectoreRemoveFeature: action.data.parcelleCode,
                currentParcelle: refParcelles,
                currentCom: refParcelles[0] ? refParcelles[0].substring(0, 5) : null,
            }
        case 'RESET_VECTOR_REMOVE_FEATURE':
            return {
                ...state,
                vectoreRemoveFeature: null,
            };
        case 'SET_CURRENT_COM':
            return {
                ...state,
                currentCom: action.data.currentCom,
            }
        case 'SET_CURRENT_COM_LABEL':
            return {
                ...state,
                currentComLabel: action.data.currentComLabel
            }
        case 'SET_LOCATION_CAPT':
            return {
                ...state,
                locationScreenCapt: action.data.locationCapt
            }
        case 'RESET_SCREEN_CAPT':
            return {
                ...state,
                locationScreenCapt: null
            }
        case 'SET_DISPLAY_MAP_TOOLS':
            return {
                ...state,
                displayMapTools: action.data
            }
        case 'REPLACE_PARCELLES':
            return {
                ...state,
                currentParcelle: action.payload, // Remplace la liste des parcelles
                currentCom: action.payload.length > 0 ? action.payload[0].substring(0, 5) : null,
            };
        case 'CLEAR_PARCELLE_LIST':
            return {
                ...state,
                currentParcelle: [], // Empty the parcelle list
                currentCom: null,    // Reset currentCom
            };
        default:
            return state
    }
}

export default MapReducer
